import type { Service, ServiceCode } from '../../types/contracts';
export const money = (value: any) => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const numberPt = (value: any) => Number(value || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
export function serviceCustomerName(code: ServiceCode, service?: Service) {
  return code === 'S1' ? 'Projeto estrutural completo em concreto armado' : service?.commercial_name || code;
}
export const digits = (value: string) => value.replace(/\D/g, '');
export function formatCpf(value: string) {
  const d = digits(value).slice(0, 11);
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}
export function formatCnpj(value: string) {
  const d = digits(value).slice(0, 14);
  return d
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
}
function checkDigits(value: string, size: number) {
  const d = digits(value);
  if (d.length !== size || /^(\d)\1+$/.test(d)) return false;
  const validate = (base: string, weights: number[]) => {
    const sum = base.split('').reduce((acc, n, i) => acc + Number(n) * weights[i], 0);
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };
  if (size === 11) {
    const a = validate(d.slice(0, 9), [10, 9, 8, 7, 6, 5, 4, 3, 2]);
    const b = validate(d.slice(0, 9) + a, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]);
    return d.endsWith(`${a}${b}`);
  }
  const a = validate(d.slice(0, 12), [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  const b = validate(d.slice(0, 12) + a, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
  return d.endsWith(`${a}${b}`);
}
export const validCpf = (value: string) => checkDigits(value, 11);
export const validCnpj = (value: string) => checkDigits(value, 14);
